(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ssg-menu-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ssg-mega-menu')) {
    class SSGMegaMenu extends HTMLElement {
      static editorState = new Map();
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const savedState = SSGMegaMenu.editorState.get(this.dataset.sectionId);
        this.activate(this.tabs.find(tab => tab.dataset.blockId === savedState?.blockId) || this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
        this.hidden = true;
        this.inert = true;
        this.addEventListener('pointerenter', () => this.cancelClose(), {signal});
        this.addEventListener('pointerleave', () => this.scheduleClose(), {signal});
        this.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.activate(tab);
          if (event.target.closest('.ssg-menu__close')) this.close(true);
        }, {signal});
        this.addEventListener('keydown', event => this.onKey(event), {signal});
        document.addEventListener('pointerdown', event => {
          if (!this.hasAttribute('data-editor-open') && !this.contains(event.target) && !this.trigger?.contains(event.target)) this.close();
        }, {signal});
        document.addEventListener('focusin', event => {
          if (!this.hasAttribute('data-editor-open') && !this.contains(event.target) && !this.trigger?.contains(event.target)) this.close();
        }, {signal});
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.hidden) { event.preventDefault(); this.close(true); }
        }, {signal});
        window.addEventListener('resize', () => {
          if (!this.desktop() && !this.hasAttribute('data-editor-open')) this.close();
          else this.position();
        }, {signal});
        window.addEventListener('scroll', () => {
          if (!this.hidden && !this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.position(); });
        }, {signal, passive:true, capture:true});
        document.addEventListener('shopify:section:load', () => this.bindTrigger(), {signal});
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open(true);
          else this.close();
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target) && event.detail.sectionId !== this.dataset.sectionId) { this.close(); return; }
          this.open(true);
          const tab = this.tabs.find(item => item.dataset.blockId === event.detail.blockId);
          if (tab) this.activate(tab);
          const selected = this.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId)}"]`);
          selected?.scrollIntoView({block:'nearest'});
        }, {signal});
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.bindTrigger(), {once:true,signal});
        else this.bindTrigger();
        if (savedState?.open) this.open(true);
      }
      disconnectedCallback() {
        this.cancelClose();
        cancelAnimationFrame(this.frame);
        this.releaseTrigger();
        this.abort?.abort();
      }
      desktop() { return window.matchMedia('(min-width:1150px)').matches; }
      bindTrigger() {
        const trigger = Array.from(document.querySelectorAll('.hdt-navigation:not(.hdt-navigation-mobile) [data-ssg-menu-key]')).find(item => item.dataset.ssgMenuKey === this.dataset.menuKey);
        if (this.trigger === trigger && trigger?.isConnected) return;
        this.releaseTrigger();
        this.trigger = trigger;
        const note = this.querySelector('.ssg-menu__editor-note');
        if (note) note.hidden = !!trigger;
        if (!trigger) return;
        this.triggerAbort = new AbortController();
        const signal = this.triggerAbort.signal;
        this.originalAttributes = Object.fromEntries(['aria-controls','aria-expanded','aria-haspopup','role'].map(name => [name,trigger.getAttribute(name)]));
        trigger.setAttribute('aria-controls',this.id);
        trigger.setAttribute('aria-expanded','false');
        trigger.setAttribute('role','button');
        trigger.removeAttribute('aria-haspopup');
        trigger.classList.add('ssg-menu-trigger');
        this.chevron = document.createElement('span');
        this.chevron.className = 'ssg-menu-chevron';
        this.chevron.setAttribute('aria-hidden','true');
        if (this.dataset.openOn === 'click') trigger.append(this.chevron);
        trigger.addEventListener('click', event => {
          if (!this.desktop()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.hidden || (this.dataset.openOn === 'hover' && event.detail > 0)) this.open(); else this.close();
        }, {signal,capture:true});
        trigger.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch' && this.dataset.openOn === 'hover') this.open();
        }, {signal});
        trigger.addEventListener('pointerleave', () => this.scheduleClose(), {signal});
        trigger.addEventListener('keydown', event => {
          if (['ArrowDown','ArrowUp',' '].includes(event.key)) {
            event.preventDefault(); this.open();
            if (event.key !== ' ') this.focusables()[event.key === 'ArrowUp' ? this.focusables().length - 1 : 0]?.focus();
          } else if (event.key === 'Tab' && !event.shiftKey && !this.hidden) {
            event.preventDefault(); this.focusables()[0]?.focus();
          }
        }, {signal});
      }
      releaseTrigger() {
        this.triggerAbort?.abort();
        this.chevron?.remove();
        if (this.trigger) {
          this.trigger.classList.remove('ssg-menu-trigger');
          for (const [name,value] of Object.entries(this.originalAttributes || {})) {
            if (value === null) this.trigger.removeAttribute(name); else this.trigger.setAttribute(name,value);
          }
        }
        this.trigger = null;
      }
      activate(tab) {
        if (!tab) return;
        this.tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected',String(active));
          item.tabIndex = active ? 0 : -1;
          const pane = document.getElementById(item.getAttribute('aria-controls'));
          if (pane) pane.hidden = !active;
        });
        if (this.hasAttribute('data-editor-open')) SSGMegaMenu.editorState.set(this.dataset.sectionId,{open:true,blockId:tab.dataset.blockId});
      }
      focusables() {
        return Array.from(this.querySelectorAll('a[href],button,[tabindex="0"]')).filter(item => item.tabIndex >= 0 && item.getClientRects().length && !item.closest('[hidden]'));
      }
      onKey(event) {
        const tab = event.target.closest('[role="tab"]');
        if (tab && ['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
          event.preventDefault();
          let index = this.tabs.indexOf(tab);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.activate(this.tabs[index]); this.tabs[index].focus();
        }
        if (event.key === 'Tab') {
          const items = this.focusables();
          if (event.shiftKey && event.target === items[0]) { event.preventDefault(); this.close(true); }
          else if (!event.shiftKey && event.target === items.at(-1)) {
            const triggers = Array.from(document.querySelectorAll('.hdt-navigation:not(.hdt-navigation-mobile) [data-ssg-menu-key]'));
            const next = triggers[triggers.indexOf(this.trigger) + 1];
            if (next) { event.preventDefault(); this.close(); next.focus(); }
          }
        }
      }
      position() {
        if (this.hidden) return;
        const rect = this.trigger?.getBoundingClientRect();
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--ssg-offset')) || 0;
        const top = Math.max(0,Math.min((rect?.bottom || 80) + offset,window.innerHeight - 100));
        if (rect && rect.bottom <= 0 && !this.hasAttribute('data-editor-open')) { this.close(); return; }
        this.style.setProperty('--ssg-top',`${top}px`);
        this.style.setProperty('--ssg-available',`${Math.max(80,window.innerHeight - top - 12)}px`);
      }
      open(editor = false) {
        if (!this.desktop() && !editor) return;
        this.cancelClose();
        document.querySelectorAll('ssg-mega-menu').forEach(menu => { if (menu !== this) menu.close(); });
        if (editor) {
          this.setAttribute('data-editor-open','');
          SSGMegaMenu.editorState.set(this.dataset.sectionId,{open:true,blockId:this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.dataset.blockId});
        }
        this.hidden = false;
        this.inert = false;
        this.trigger?.setAttribute('aria-expanded','true');
        this.position();
      }
      close(returnFocus = false) {
        this.cancelClose();
        const savedState = SSGMegaMenu.editorState.get(this.dataset.sectionId);
        if (savedState) savedState.open = false;
        this.hidden = true;
        this.inert = true;
        this.removeAttribute('data-editor-open');
        this.trigger?.setAttribute('aria-expanded','false');
        if (returnFocus) this.trigger?.focus({preventScroll:true});
      }
      scheduleClose() {
        this.cancelClose();
        if (this.dataset.openOn === 'hover' && !this.hasAttribute('data-editor-open')) this.timer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, Number(this.dataset.closeDelay) || 250);
      }
      cancelClose() { clearTimeout(this.timer); }
    }
    customElements.define('ssg-mega-menu',SSGMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ssg-storefront-extras"] && !Shopify.designMode) return;
  try {
    (function () {
  function injectTopBarLinks() {
    const socials = document.querySelector('.hdt-top-bar__item.hdt-top-bar__socials');
    if (!socials) return;
    if (socials.querySelector('.cmm-topbar-links')) return;
    const ul = socials.querySelector('.hdt-socials__list, ul');
    const wrap = document.createElement('div');
    wrap.className = 'cmm-topbar-links';
    wrap.innerHTML = '<a href="/pages/downloads-instructions">Downloads</a><span class="cmm-topbar-divider" aria-hidden="true">|</span><a href="/pages/manuals">Manual</a><span class="cmm-topbar-divider" aria-hidden="true">|</span><a href="/pages/contact">Contact Us</a>';
    const header = document.querySelector('.hdt-section-header.hdt-header-inline');
    if (header && !document.querySelector('.cmm-mobile-utility')) {
      const mobile = document.createElement('nav');
      mobile.className = 'cmm-mobile-utility';
      mobile.setAttribute('aria-label', 'Support links');
      mobile.innerHTML = wrap.innerHTML;
      header.parentNode.insertBefore(mobile, header);
    }
    if (ul) {
      socials.insertBefore(wrap, ul);
    } else {
      socials.insertBefore(wrap, socials.firstChild);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTopBarLinks);
  } else {
    injectTopBarLinks();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
